// extracted by mini-css-extract-plugin
export default {"instruction":"Instruction_instruction__Jrtst","instruction_defaultFields":"Instruction_instruction_defaultFields__3RcmD"};